<template>
  <section style="width: 1200px">
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1200px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ title }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>

            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select
                v-model="form.sort"
                name="sort"
                :placeholder="
                  $t('message.please_select') + $t('attributes.sort')
                "
                expanded
              >
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="type"
              :label="$t('attributes.offer_type')"
            >
              <b-select
                v-model="form.type"
                name="type"
                :disabled="isUpdate"
                expanded
              >
                <option value="D">
                  {{ $t('attributes.offer_bank_type') }}
                </option>
              </b-select>
            </form-group>

            <form-group horizontal name="topic" :label="$t('attributes.topic')">
              <b-input
                v-model="form.topic"
                name="topic"
                :placeholder="
                  $t('message.please_input') + $t('attributes.topic')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="create_date"
              attribute="attributes.offer_dates"
              :label="$t('attributes.offer_dates')"
            >
              <b-datepicker
                :placeholder="
                  $t('message.please_select') + $t('attributes.offer_dates')
                "
                v-model="selectedDates"
                range
                @input="onSelectedDates"
              >
              </b-datepicker>
            </form-group>

            <form-group
              horizontal
              name="picture"
              attribute="attributes.picture"
              :label="$t('attributes.picture')"
              grouped
            >
              <template #label>
                {{ $t('attributes.picture') }}
                <b-tooltip type="is-dark" label="600*400/限定jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPictureImage">
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <figure v-if="form.picture" class="picture">
                  <a
                    :href="OfferImage(form.picture)"
                    @click.prevent="onClickImage(form.picture)"
                  >
                    <img
                      :src="OfferImage(form.picture)"
                      :alt="$t('attributes.picture')"
                      style="height: 40px; width: auto; margin-left: 6px;"
                    />
                  </a>
                </figure>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="logo"
              attribute="attributes.logo"
              :label="$t('attributes.logo')"
              grouped
            >
              <template #label>
                {{ $t('attributes.logo') }}
                <b-tooltip type="is-dark" label="600*400/限定jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a class="button is-primary" @click="onSelectLogoImage">
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <figure v-if="form.logo" class="picture">
                  <a
                    :href="OfferImage(form.logo)"
                    @click.prevent="onClickImage(form.logo)"
                  >
                    <img
                      :src="OfferImage(form.logo)"
                      :alt="$t('attributes.logo')"
                      style="height: 40px; width: auto; margin-left: 6px;"
                    />
                  </a>
                </figure>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="url"
              :label="$t('attributes.news_link_type')"
            >
              <template #label>
                {{ $t('attributes.news_link_type') }}
                <b-tooltip type="is-dark" label="設定外連就不會進入內頁">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-input
                v-model="form.url"
                name="topic"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.magazine_link_list')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="content"
              attribute="attributes.description"
              :label="$t('attributes.description')"
            >
              <div class="content">
                <editor
                  ref="content_editor"
                  v-model="form.content"
                  image-type="News"
                ></editor>
              </div>
            </form-group>

            <form-group
              v-show="form.type === 'D'"
              horizontal
              name="content1"
              attribute="attributes.content"
              :label="$t('attributes.content')"
            >
              <div class="content">
                <editor
                  ref="content1_editor"
                  v-model="form.content1"
                  image-type="News"
                ></editor>
              </div>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ isUpdate ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>

        <b-modal :active.sync="isImageModalActive">
          <p class="image">
            <img :src="OfferImage(selectedImageUrl)" alt="" />
          </p>
        </b-modal>

        <b-loading
          :active.sync="isLoading"
          :is-full-page="false"
          :can-cancel="false"
        ></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import { OpenOfferFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'OfferForm',
  components: { Editor },

  props: {
    offer: {
      type: Object,
      required: true
    }
  },
  data() {
    const isUpdate = !!this.offer.id
    const title = isUpdate
      ? this.$t('attributes.modify')
      : this.$t('attributes.add')

    const today = this.$dayjs()
    const startDate = this.offer.start_date
      ? this.$dayjs(this.offer.start_date).toDate()
      : today.toDate()
    const endDate = this.offer.end_date
      ? this.$dayjs(this.offer.end_date).toDate()
      : today.toDate()

    return {
      isUpdate: isUpdate,
      title: title,

      sortOptions: [...Array(10).keys()].map(i => i + 1),

      selectedDates: [startDate, endDate],

      sending: false,
      form: this.extractFormValues(this.offer),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      status: { required },
      sort: { required },
      type: { required },
      area_code: {
        requiredIf: requiredIf(function(model) {
          return model.type === 'C'
        })
      },
      subarea: {
        requiredIf: requiredIf(function(model) {
          return model.type === 'C'
        }),
        maxLength: maxLength(10)
      },
      topic: { required, maxLength: maxLength(100) },
      content: {},
      content1: {},
      picture: { maxLength: maxLength(200) },
      logo: { maxLength: maxLength(200) },
      start_date: { required },
      end_date: { required },
      url: {}
    }
  },
  computed: {
    isLoading() {
      return this.sending
    }
  },
  methods: {
    extractFormValues(data) {
      const today = this.$dayjs()
      const startDate = data.start_date
        ? this.$dayjs(data.start_date).toDate()
        : today.toDate()
      const endDate = data.end_date
        ? this.$dayjs(data.end_date).toDate()
        : today.toDate()

      this.selectedDates = [startDate, endDate]

      return {
        id: data.id,
        status: data.status,
        sort: data.sort,
        type: data.type,
        topic: data.topic,
        content: data.content,
        content1: data.content1,
        picture: data.picture,
        logo: data.logo,
        start_date: this.formatDate(startDate),
        end_date: this.formatDate(endDate),
        url: data.url
      }
    },
    async onSelectPictureImage() {
      try {
        this.form.picture = await OpenOfferFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectLogoImage() {
      try {
        this.form.logo = await OpenOfferFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    onSelectedDates() {
      this.form.start_date = this.formatDate(this.selectedDates[0])
      this.form.end_date = this.formatDate(this.selectedDates[1])
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async onSend() {
      this.form.content = this.$refs.content_editor.getData()
      this.form.content1 = this.$refs.content1_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
